import { legacy_createStore, applyMiddleware, combineReducers } from "redux";
import {thunk} from "redux-thunk";
import  authReducer  from "../redux/AuthReducer/reducer.js";
import  postReducer from "../redux/postReducer/reducer.js";




export interface RootState {
    authReducer: any;
    postReducer: any;
  }
const rootReducer = combineReducers<RootState>({authReducer,postReducer});

export const store = legacy_createStore(rootReducer, applyMiddleware(thunk) );